__turbopack_context__.v({
  "arrow": "Working-module-scss-module__0A0Otq__arrow",
  "body": "Working-module-scss-module__0A0Otq__body",
  "content": "Working-module-scss-module__0A0Otq__content",
  "header": "Working-module-scss-module__0A0Otq__header",
  "img": "Working-module-scss-module__0A0Otq__img",
  "imgWrapper": "Working-module-scss-module__0A0Otq__imgWrapper",
  "item": "Working-module-scss-module__0A0Otq__item",
  "list": "Working-module-scss-module__0A0Otq__list",
  "main": "Working-module-scss-module__0A0Otq__main",
});
